import { PLATFORM } from 'aurelia-pal';
import { EventAggregator } from 'aurelia-event-aggregator';
import { HttpClient } from 'aurelia-fetch-client';
import { Router } from 'aurelia-router';

import { NAVIGATION } from './constants/navigation.constant';
import { AppAPI } from './services/appAPI.service';


const appComponent = PLATFORM.moduleName('./components/app/app');

export const configure = (aurelia) => {
  // Framework services
  aurelia.container.registerAlias(EventAggregator, 'eventAggregator');
  aurelia.container.registerAlias(HttpClient, 'httpClient');
  aurelia.container.registerAlias(Router, 'router');

  // Constants
  aurelia.container.registerInstance('NAVIGATION', NAVIGATION);

  // Services
  aurelia.container.registerSingleton('appAPI', AppAPI);

  // Components
  aurelia.globalResources(appComponent);
};
